export default __webpack_public_path__ + "static/media/homehero.83c7cd18.webp";